<template>
  <v-container class="pt-1 pb-12 py-sm-12 px-4 px-sm-0">

    <v-overlay :value="dataset.loading" absolute>
      <v-progress-circular indeterminate size="64" />
    </v-overlay>

    <!-- HEADER DESKTOP -->
<v-row class="d-none d-sm-flex">
  <v-col cols="12">
    <div class="title-container d-flex justify-space-between align-center">
 <div>
  <div class="d-flex align-center ga-3">
    <span class="page-title">{{ page.title }}</span>
    <v-menu offset-y transition="slide-y-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small color="primary" text v-bind="attrs" v-on="on">
          <v-icon left>mdi-help-circle-outline</v-icon>Ajuda
        </v-btn>
      </template>

      <v-card min-width="380px" class="help-dropdown">
        <v-card-title class="text-h6 font-weight-bold pb-2">
          <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>
          Ajuda dos Campos
        </v-card-title>
        <v-divider></v-divider>
        
        <v-card-text class="pt-3 pb-3 help-content">
          <div class="help-item mb-3">
            <p class="font-weight-bold text-caption mb-1">📝 Nome do Combo</p>
            <p class="text-caption grey--text">Identificador único do combo (ex: Combo Premium)</p>
          </div>
          
          <v-divider class="my-2"></v-divider>
          
          <div class="help-item mb-3">
            <p class="font-weight-bold text-caption mb-1">💵 Valor Pago</p>
            <p class="text-caption grey--text">Valor que o cliente paga para obter o crédito</p>
          </div>
          
          <v-divider class="my-2"></v-divider>
          
          <div class="help-item mb-3">
            <p class="font-weight-bold text-caption mb-1">🎁 Valor Recebido</p>
            <p class="text-caption grey--text">Valor de crédito que o cliente receberá (bônus incluído)</p>
          </div>
          
          <v-divider class="my-2"></v-divider>
          
          <div class="help-item mb-3">
            <p class="font-weight-bold text-caption mb-1">🔢 Posição</p>
            <p class="text-caption grey--text">Ordem de exibição no totem (1, 2, 3... em crescente)</p>
          </div>
          
          <v-divider class="my-2"></v-divider>
          
          <div class="help-item">
            <p class="font-weight-bold text-caption mb-1">✅ Habilitado</p>
            <p class="text-caption grey--text">Marque para ativar o combo ou desmarque para desativar</p>
          </div>
        </v-card-text>
      </v-card>
     </v-menu>
  </div>
  <v-breadcrumbs
    class="app-breadcrumb"
    divider="›"
    :items="dataset.breadcrumbItems"
  />
</div>

      <div class="button-group">
 <v-btn
  type="button"
  elevation="0"
  outlined
  depressed
  style="color: #3BA5DB !important; border-color: #3BA5DB !important;"
  @click="voltar"
  :disabled="dataset.loading"
>
  Voltar
</v-btn>
<v-btn
  color="info"
  dark
  @click="abrirConfirmacao"
  :loading="dataset.loading"
>
  Salvar
</v-btn>
</div>
    </div>
  </v-col>
</v-row>

<!-- HEADER MOBILE -->
<v-row class="d-flex d-sm-none mb-4">
  <v-col cols="12">
    <div class="d-flex align-center">
      <span class="page-title">{{ page.title }}</span>
      <v-btn icon small color="primary" class="ml-2" @click="dialogAjudaMobile = true">
          <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </div>
    <v-breadcrumbs
      class="app-breadcrumb"
      divider="›"
      :items="dataset.breadcrumbItems"
    />
  </v-col>
<v-col cols="6">
  <v-btn color="primary" outlined block @click="voltar" :disabled="dataset.loading">Voltar</v-btn>
</v-col>
<v-col cols="6">
  <v-btn color="info" dark block @click="abrirConfirmacao" :loading="dataset.loading">Salvar</v-btn>
</v-col>
</v-row>

    <v-form ref="form" v-model="valid" :disabled="dataset.loading">

      <!-- DETALHES -->
      <v-row>
        <v-col cols="12">
          <v-card class="card-form-outlined">
            <v-card-title class="card-group-title">Detalhes do Combo</v-card-title>
            <v-card-text>
              <v-row>

                <v-col cols="12" sm="6" class="pb-0">
               <v-text-field
                    dense
                    label="Nome do Combo"
                    v-model="combo.nome"
                    outlined
                    maxlength="30"
                    counter="30"
                    :rules="[rules.required]"
                  />
                </v-col>

                <v-col cols="12" sm="3" class="pb-0">
                  <v-text-field
                    dense
                    label="Valor Pago (R$)"
                    v-model="combo.valorPago"
                    outlined
                    placeholder="0,00"
                    reverse
                    :rules="[rules.required, rules.valor]"
                    @input="formatarValor('valorPago', $event)"
                  />
                </v-col>

                <v-col cols="12" sm="3" class="pb-0">
                  <v-text-field
                    dense
                    label="Valor Recebido (R$)"
                    v-model="combo.valorRecebido"
                    outlined
                    placeholder="0,00"
                    reverse
                    :rules="[rules.required, rules.valor]"
                    @input="formatarValor('valorRecebido', $event)"
                  />
                </v-col>

              <v-col cols="12" sm="3" class="pb-0">
  <v-text-field
    dense
    label="Posição"
    v-model="combo.posicao"
    outlined
    type="number"
    :rules="[rules.required, rules.posicao]"
  />
</v-col>

<v-col cols="12" sm="3" class="pb-0 d-flex align-center" style="height: 56px; margin-top: 0px;">
  <v-switch
    v-model="combo.habilitado"
    :label="combo.habilitado ? 'Habilitado' : 'Desabilitado'"
    color="success"
    hide-details
    inset
    class="ma-0"
  />
</v-col>

              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- AÇÕES -->
      <v-row>
        <v-col cols="12">
          <v-card class="card-form-outlined">
            <v-card-title class="card-group-title">Ações</v-card-title>
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12" sm="auto">
             <v-btn outlined style="color: #f44336 !important; border-color: #f44336 !important;" block @click="dialogExcluir = true">
  Excluir Combo
</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

    </v-form>

    <!-- DIALOG CONFIRMAR SALVAR -->
    <v-dialog v-model="dialogConfirmar" max-width="400">
      <v-card>
        <v-card-title>Atualizar Combo</v-card-title>
        <v-card-text>Deseja atualizar este combo?</v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialogConfirmar = false">Cancelar</v-btn>
          <v-btn text color="primary" @click="salvar">Atualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG CONFIRMAR EXCLUIR -->
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card>
        <v-card-title>Excluir Combo</v-card-title>
        <v-card-text>Deseja realmente excluir este combo?</v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text color="error" @click="dialogExcluir = false">Cancelar</v-btn>
          <v-btn color="primary" @click="excluir">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
<v-dialog v-model="dialogAjudaMobile" scrollable content-class="popup-mobile-dialog">
    <v-card>
        <div class="popup-mobile-header">
            <span class="popup-mobile-header-title">
                <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
            </span>
            <v-btn icon small class="popup-mobile-close" @click="dialogAjudaMobile = false">
                <v-icon size="18">mdi-close</v-icon>
            </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text class="pt-3 pb-3">
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📝 Nome do Combo</p><p class="text-caption grey--text">Identificador único do combo (ex: Combo Premium)</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">💵 Valor Pago</p><p class="text-caption grey--text">Valor que o cliente paga para obter o crédito</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🎁 Valor Recebido</p><p class="text-caption grey--text">Valor de crédito que o cliente receberá (bônus incluído)</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔢 Posição</p><p class="text-caption grey--text">Ordem de exibição no totem (1, 2, 3... em crescente)</p></div>
            <v-divider class="my-2"></v-divider>
            <div><p class="font-weight-bold text-caption mb-1">✅ Habilitado</p><p class="text-caption grey--text">Marque para ativar o combo ou desmarque para desativar</p></div>
        </v-card-text>
    </v-card>
</v-dialog>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  name: "ComboEdit",

  data() {
    return {
      valid: false,
      dialogConfirmar: false,
      dialogExcluir: false,
      dialogAjudaMobile: false,

      dataset: {
        loading: false,
        breadcrumbItems: [
          { text: "Homepage", to: "/home" },
          { text: "Combos", to: "/combos" },
          { text: "Editar Combo", disabled: true }
        ]
      },

      page: { title: "Editar Combo" },
combo: {
    id: null,
    nome: "",
    valorPago: "",
    valorRecebido: "",
    habilitado: true,
    posicao: ""  // ← NOVO
},

      rules: {
    required: v => !!v || "Campo obrigatório",
    valor: v => {
      if (!v) return "Campo obrigatório";
      const n = parseFloat(String(v).replace(",", "."));
      return (!isNaN(n) && n > 0) || "Informe um valor válido";
    },
    posicao: v => {  // ← NOVO
      if (!v) return "Posição é obrigatória";
      const n = parseInt(v);
      return (!isNaN(n) && n > 0) || "Posição deve ser um número maior que zero";
    }
}
    };
  },

  async created() {
    await this.buscar();
  },

  methods: {
    async buscar() {
      this.dataset.loading = true;
      try {
        const id = this.$route.params.id;
        const res = await axios.get("/api/combos/" + id);
        this.combo = {
  ...res.data,
  valorPago: Number(res.data.valorPago).toFixed(2).replace(".", ","),
  valorRecebido: Number(res.data.valorRecebido).toFixed(2).replace(".", ","),
  posicao: res.data.posicao || ""  // ← NOVO
};
      } catch (err) {
        this.$dialog.notify.error("Erro ao carregar combo.", { position: "top-right", timeout: 4000 });
        this.voltar();
      } finally {
        this.dataset.loading = false;
      }
    },

    formatarValor(campo, v) {
      if (!v) { this.combo[campo] = ""; return; }
      const limpo = v.replace(/\D/g, "");
      if (!limpo) { this.combo[campo] = ""; return; }
      this.combo[campo] = (parseInt(limpo) / 100).toFixed(2).replace(".", ",");
    },

    abrirConfirmacao() {
      if (!this.$refs.form.validate()) {
        this.$dialog.notify.error("Preencha os campos obrigatórios corretamente.", {
          position: "top-right", timeout: 4000
        });
        return;
      }
      this.dialogConfirmar = true;
    },

    async salvar() {
      this.dialogConfirmar = false;
      this.dataset.loading = true;
      try {
       await axios.put("/api/combos/" + this.combo.id, {
  id: this.combo.id,
  nome: this.combo.nome,
  valorPago: parseFloat(String(this.combo.valorPago).replace(",", ".")),
  valorRecebido: parseFloat(String(this.combo.valorRecebido).replace(",", ".")),
  habilitado: this.combo.habilitado,
  posicao: parseInt(this.combo.posicao),
  operacaoId: localStorage.getItem('operation')
        });

        this.$dialog.notify.info("Combo atualizado com sucesso.", { position: "top-right", timeout: 3000 });
        this.voltar();
      } catch (err) {
        let msg = "Erro ao atualizar combo.";
        if (err && err.response && err.response.data && err.response.data.mensagem) msg = err.response.data.mensagem;
        this.$dialog.notify.error(msg, { position: "top-right", timeout: 5000 });
      } finally {
        this.dataset.loading = false;
      }
    },

    async excluir() {
      this.dialogExcluir = false;
      this.dataset.loading = true;
      try {
        await axios.delete("/api/combos/" + this.combo.id);
        this.$dialog.notify.success("Combo excluído com sucesso.", { position: "top-right", timeout: 3000 });
        this.voltar();
      } catch (err) {
        let msg = "Erro ao excluir combo.";
        if (err && err.response && err.response.data && err.response.data.mensagem) msg = err.response.data.mensagem;
        this.$dialog.notify.error(msg, { position: "top-right", timeout: 5000 });
      } finally {
        this.dataset.loading = false;
      }
    },

    voltar() {
      this.$router.push("/combos");
    }
  }
};
</script>

<style scoped>
.v-card { border-radius: 12px; }
.title-container { gap: 16px; }
.page-title { font-size: 24px; font-weight: 700; }
.v-btn { min-width: 130px; font-weight: 600; }
.card-group-title { font-size: 16px !important; font-weight: 600; }

.ga-3 {
  gap: 24px;
}

.help-dropdown {
  border-radius: 8px !important;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1) !important;
}

.help-content {
  max-height: 400px;
  overflow-y: auto;
}
.popup-mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px 16px;
}

.popup-mobile-header-title {
  font-size: 17px;
  font-weight: 700;
  color: #333;
  display: flex;
  align-items: center;
}

.popup-mobile-close.v-btn {
  background-color: #f0f0f0 !important;
  border-radius: 50% !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  box-shadow: none !important;
}

.popup-mobile-close.v-btn .v-icon {
  color: #555 !important;
}

.popup-mobile-dialog {
  border-radius: 12px;
}
</style>